import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchAssignedBijlagen'
import type { AssignedBijlagenSearch } from '../types/AssignedBijlagenSearch'

export { useAssignedBijlagenSearchStore }

const useAssignedBijlagenSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<AssignedBijlagenSearch['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
